<template>
  <span>
    <b>{{ name }}</b>
  </span>
</template>

<script>
export default {
  name: 'JudgeNameHelper',
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      name: ''
    }
  },
  mounted () {
    this.$store
      .dispatch('users/GET_USER', this.id)
      .then(res => {
        console.log(res)
        this.name = `${res.data.users[0].firstName} ${res.data.users[0].lastName}`
      })
  }
}
</script>
